import React, { useEffect, useState, Suspense } from "react";
import Navbar from './Navbar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom'; 
import { useLocation } from 'react-router-dom';
import usePrebid from "./prebid/usePrebid";
import AdUnit from './prebid/AdUnit'; 
import ConsentManager from "./consentManagement/ConsentManager";

const Layout = ({ handleModal }) => {
  const [footerFallback, setFooterFallback] = useState(false);
  const location = useLocation();
  const { adUnitsRegistered, isGDPR, showBanner } = usePrebid();
  const isMobile = window.innerWidth <= 480; 
  const [navAdRendered, setNavAdRendered] = useState(false);


  // Handle Footer visibility logic on route change
  useEffect(() => {
    // Hide the footer on route change
    setFooterFallback(false);
    // Set a timer to show the footer after 2 seconds
    const timer = setTimeout(() => {
      setFooterFallback(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [location.pathname]); 

  // Show the footer 
  const showFooter = footerFallback ;

 
  const noAdPage = location.pathname.includes("checkout") || location.pathname.includes("subscription");

  return (
    <div className="flex flex-col min-h-screen">

    {isGDPR && showBanner && <ConsentManager />}


		{!noAdPage && adUnitsRegistered && (
		  isMobile ? (
		    <AdUnit
		      adUnitCode="navbar-mobile"
		      onAdRendered={() => setNavAdRendered(true)}
		    />
		  ) : (
		    <AdUnit
		      adUnitCode="navbar-ad"
		      onAdRendered={() => setNavAdRendered(true)}
		    />
		  )
		)}


		{!noAdPage && !navAdRendered && (
		  isMobile 
		    ? <div id="mob-banner-ad-b" />   
		    : <div id="dsk-banner-ad-b" />   
		)}


      <Navbar handleModal={handleModal} />

      <main className="flex-grow min-h-screen">
        <Suspense>
          <Outlet />
        </Suspense>
      </main>


      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
